import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { VendorService } from '../../services/vendor.service';
import { PrintService } from '../../services/print.service';
import * as FileSaver from 'file-saver';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-vendor-daily-transactions',
	templateUrl: './vendor-daily-transactions.component.html',
	styleUrls: ['./vendor-daily-transactions.component.scss']
})
export class VendorDailyTransactionsComponent implements OnInit {

	@ViewChild('print_table') printtable: ElementRef;
	@ViewChild('details') detailsRef: ElementRef;

	private sort: MatSort;

	@ViewChild(MatSort) set matSort(ms: MatSort) {
		this.sort = ms;
		this.setDataSourceAttributes();
	}

	@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
		this.paginator = mp;
		this.setDataSourceAttributes();
	}

	setDataSourceAttributes() {
		if (this.dataSource) {
			this.dataSource.paginator = this.paginator;
		}
	}

	color = 'blue';
	payments: any = [];
	vendors: any = [];
	today = new Date();
	filename = 'vendordailytransactions';
	title = 'Vendor Daily Transactions';
	datefrom = new UntypedFormControl(this.today);
	dateto = new UntypedFormControl(this.today);
	running = false;
	displaydetails: any = false;
	total_trans: any = 0;
	total_sub: any = 0;
	total_tax: any = 0;
	total_fee: any = 0;
	total_discount: any = 0;
	selectedvendors = new UntypedFormControl([]);
	selectedtypes = new UntypedFormControl([20, 21, 22]);
	searcher = new UntypedFormControl('');
	exporting = false;
	config: any = false;
	user: any = false;

	dataSource: MatTableDataSource<any>;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	dataObs: any;
	items_per_page = [25, 50, 100, 200, 500];
	pagesizedefault = 200;
	searchresults: any = false;

	cctotal = 0;
	total_pay: any = 0;
	payment_methods: any = false;

	type_filters = [
		{ value: 20, name: 'Invoice' },
		{ value: 21, name: 'Credit' },
		{ value: 22, name: 'Payment' },
	];

	constructor(
		private _changeDetectorRef: ChangeDetectorRef,
		private location: Location,
		private printService: PrintService,
		private globalSearchService: GlobalSearchService,
		private globalsService: GlobalsService,
		private vendorService: VendorService,
		private route: ActivatedRoute,
		public router: Router,
		private modalService: NgbModal
	) {
		this.globalSearchService.configsubscription.subscribe(s => {
			this.config = s;
		});

		this.color = this.globalSearchService.getColor();

		this.globalSearchService.payment_methods.subscribe(r => {
			this.payment_methods = r;
		});

		this.globalSearchService.user.subscribe(results => {
			this.user = results;
		});

		this.vendorService.getVendors().subscribe((results: any) => {
			this.vendors = results;
		});

		this.searcher.valueChanges.subscribe(newValue => {
			this.filterSearch();
		});
	}

	filterSearch() {
		if (this.searcher.value == '') {
			this.searchresults = this.payments.transactions;
			this.setPagination(this.searchresults);
		} else {
			this.searchresults = this.globalSearchService.filterItem(
				this.payments.transactions,
				this.searcher.value,
				'transno,supplierno,suppname,trandate,suppreference'
			);
			this.setPagination(this.searchresults);
		}
	}

	ngOnInit(): void {
		this.setPagination([]);
	}

	loadData() {
		this.running = true;
		const data = {
			from: this.datefrom.value,
			to: this.dateto.value,
			vendors: this.selectedvendors.value,
			types: this.selectedtypes.value
		};
		this.vendorService.getDailyTransactions(data).subscribe((results: any) => {
			this.running = false;
			this.payments = results;

			if (results.transactions.length) {
				this.items_per_page = [25, 50, 100, 500, results.transactions.length];
			}

			this.setPagination(results.transactions);

			const calculateTotal = (transactions: any[], key: string) =>
				transactions.reduce((accumulator: number, item: any) => accumulator + parseFloat(item[key] || 0), 0);

			this.total_trans = calculateTotal(results.transactions, 'total');
			this.total_sub = calculateTotal(results.transactions, 'ovamount');
			this.total_tax = calculateTotal(results.transactions, 'ovgst');
			this.total_fee = calculateTotal(results.transactions, 'ovfee');
			this.total_discount = calculateTotal(results.transactions, 'discountavail');

			this.cctotal = results.summary.reduce((accumulator: number, item: any) => {
				const ttype = this.payment_methods ? this.payment_methods.find((t: any) => t.paymentname === item.type) : null;
				const value = (ttype && ttype.cc_process === '1') ? parseFloat(item.amount) : 0;
				return accumulator + value;
			}, 0);

			this.total_pay = results.summary.reduce((accumulator: number, item: any) => accumulator + parseFloat(item.amount || 0), 0);
		});
	}

	getVendorNamesFormatted(): string {
		if (!this.selectedvendors.value.length) {
			return 'All Vendors';
		}

		return this.selectedvendors.value.map(v => {
			const vendor = this.vendors.find((r: any) => v === r.supplierid);
			return vendor ? vendor.suppname : '';
		}).filter(Boolean).join(', ');
	}

	exportPdf() {
		this.exporting = true;
		this.generateHtml().then((html) => {
			const encoded: string = this.globalSearchService.base64encode(html);
			const today = new Date();
			const vendors = this.selectedvendors.value && this.selectedvendors.value.length > 0 ?
				this.selectedvendors.value.join(',') :
				'All Vendors';

			const data = {
				content: encoded,
				filename: this.filename,
				landscape: true,
				title: 'Vendor Daily Transactions',
				subtitle: 'Vendors: ' + vendors + ' ' + this.datefrom.value.toLocaleDateString() + ' - ' + this.dateto.value.toLocaleDateString() + ' created ' + today.toLocaleString()
			};

			this.exporting = true;
			this.printService.pdf(data).subscribe((result: any) => {
				this.exporting = false;
				this.globalSearchService.downloadPdf(result.content, data.filename);
			});
		}).catch((error) => {
			console.error('Error generating HTML:', error);
			this.exporting = false;
		});
	}

	exportXls() {
		this.exporting = true;
		this.generateHtml().then((html) => {
			const encoded: string = this.globalSearchService.base64encode(html);
			const today = new Date();
			const vendors = this.selectedvendors.value && this.selectedvendors.value.length > 0 ?
				this.selectedvendors.value.join(',') :
				'All Vendors';

			const data = {
				content: encoded,
				filename: this.filename,
				title: 'Vendor Daily Transactions',
				subtitle: 'Vendors: ' + vendors + ' ' + this.datefrom.value.toLocaleDateString() + ' - ' + this.dateto.value.toLocaleDateString() + ' created ' + today.toLocaleString()
			};

			this.printService.xls(data).subscribe((result: any) => {
				this.exporting = false;
				this.globalSearchService.downloadXls(result.content, data.filename);
			});
		}).catch((error) => {
			console.error('Error generating HTML:', error);
			this.exporting = false;
		});
	}

	financial(x) {
		if (x == null || isNaN(Number(x))) {
			return '0.00';
		}
		return Number(x).toFixed(2);
	}

	generateHtml(): Promise<string> {
		const allTransactions = this.payments.transactions.map((pay: any) => ({
			trandate: pay.trandate,
			transno: pay.transno,
			typename: pay.typename,
			supplierno: pay.supplierno,
			suppname: pay.suppname,
			suppreference: pay.suppreference,
			ovamount: this.financial(pay.ovamount),
			ovgst: this.financial(pay.ovgst),
			ovfee: this.financial(pay.ovfee),
			discountavail: this.financial(pay.discountavail),
			total: this.financial(pay.total),
			alloc: this.financial(pay.alloc),
			balance: this.financial(pay.balance),
			settled: pay.settled,
		}));

		const roundedSummary = this.payments.summary.map((p: any) => ({
			...p,
			amount: this.financial(p.amount)
		}));

		const roundedTotals = {
			total_sub: this.financial(this.total_sub),
			total_tax: this.financial(this.total_tax),
			total_fee: this.financial(this.total_fee),
			total_discount: this.financial(this.total_discount),
			total_trans: this.financial(this.total_trans),
			cctotal: this.financial(this.cctotal),
			total_pay: this.financial(this.total_pay),
		};

		return new Promise((resolve) => {
			let htmlParts: string[] = [];

			htmlParts.push(`
				<div class="table">
					<div class="bg-white mt-2 rounded">
						<div id="receipts">
							<h4 class="mt-2 mb-4 noprint">${this.title} ${this.getVendorNamesFormatted()}</h4>
							<table id="rcptTable" name="rcptTable" class="table compact table-sm table-fixed collapsed">
								<thead>
									<tr>
										<th class="text-center">Date</th>
										<th class="text-center">Document#</th>
										<th class="text-center">Type</th>
										<th class="text-right">Vendor#</th>
										<th class="text-left">Vendor Name</th>
										<th class="text-center">Reference</th>
										<th class="text-right">Amount</th>
										<th class="text-right">Tax</th>
										<th class="text-right">Fee</th>
										<th class="text-right">Discount</th>
										<th class="text-right"><b>Total</b></th>
										<th class="text-right"><b>Applied</b></th>
										<th class="text-right"><b>Balance</b></th>
										<th class="text-center">Settled</th>
									</tr>
								</thead>
								<tbody>`);

			allTransactions.forEach((pay: any) => {
				htmlParts.push(`
					<tr>
						<td class="text-center">${pay.trandate || ''}</td>
						<td class="text-center">${pay.transno || ''}</td>
						<td class="text-center">${pay.typename || ''}</td>
						<td class="text-right text-nowrap">
							<a href="/vendors/view/${pay.supplierno}">
								<b>${pay.supplierno || ''}</b>
							</a>
						</td>
						<td class="text-left name-column">${pay.suppname || ''}</td>
						<td class="text-center">${pay.suppreference || ''}</td>
						<td class="text-right">${pay.ovamount}</td>
						<td class="text-right">${pay.ovgst}</td>
						<td class="text-right">${pay.ovfee}</td>
						<td class="text-right">${pay.discountavail}</td>
						<td class="text-right">${pay.total}</td>
						<td class="text-right ${pay.settled === 'Yes' ? 'text-success' : 'text-danger'}">${pay.alloc}</td>
						<td class="text-right">${pay.balance}</td>
						<td class="text-center">${pay.settled || ''}</td>
					</tr>`);
			});

			htmlParts.push(`
					<tr>
						<td class="text-center"><b>TOTALS</b></td>
						<td class="text-center"></td>
						<td class="text-center"></td>
						<td class="text-center"></td>
						<td class="text-center"></td>
						<td class="text-center"></td>
						<td class="text-right">${roundedTotals.total_sub}</td>
						<td class="text-right">${roundedTotals.total_tax}</td>
						<td class="text-right">${roundedTotals.total_fee}</td>
						<td class="text-right">${roundedTotals.total_discount}</td>
						<td class="text-right">${roundedTotals.total_trans}</td>
						<td class="text-center"></td>
						<td class="text-center"></td>
						<td class="text-center"></td>
					</tr>
				</tbody>
			</table>

			<table class="table table-fixed compact table-sm w-50 collapsed">
				<thead>
					<tr>
						<th>Type</th>
						<th class="text-right">Amount</th>
					</tr>
				</thead>
				<tbody>`);

			roundedSummary.forEach((p: any) => {
				htmlParts.push(`
					<tr>
						<td>${p.type || ''}</td>
						<td class="text-right">${p.amount}</td>
					</tr>`);
			});

			htmlParts.push(`
					<tr>
						<th>CC Total</th>
						<th class="text-right">${roundedTotals.cctotal}</th>
					</tr>
					<tr>
						<th>Total</th>
						<th class="text-right">${roundedTotals.total_pay}</th>
					</tr>
				</tbody>
			</table>
			</div>
		</div>
	</div>`);

			resolve(htmlParts.join(''));
			htmlParts = null;
		});
	}

	back(): void {
		this.location.back();
	}

	setPagination(tableData) {
		this.dataSource = new MatTableDataSource<any>(tableData);
		this._changeDetectorRef.detectChanges();
		if (this.dataSource) {
			this.dataSource.paginator = this.paginator;
		}
		this.dataObs = this.dataSource.connect();
	}

	openDocument(transaction: any, display: string) {
		switch (transaction.type) {
		case '21':
			this.globalsService.getVendorCreditNote(transaction.id, display).subscribe((result: any) => {
				this.displaydetails = result;
				this.modalService.open(this.detailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((mresult) => {}, (reason) => {});
			});
			break;
		case '20':
			this.globalsService.getVendorInvoice(transaction.id, display).subscribe((result: any) => {
				this.displaydetails = result;
				this.modalService.open(this.detailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((mresult) => {}, (reason) => {});
			});
			break;
		}
	}

}


